export default "__VITE_ASSET__ip2BYDLW__"